var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[(_vm.parmas.series)?_c('div',{ref:"myChart",staticClass:"charts",staticStyle:{"width":"100%","height":"100%"},attrs:{"parmas":_vm.parmas}}):_c('dv-loading',[_vm._v("Loading...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }